<template>
  <CustomRow class="unverified">
    <v-card class="alert-card d-flex align-center">
      <template v-if="reSendFinished">
        <div v-html="$t('send_email_content', { mail: userInfo.email })"></div>
      </template>
      <template v-else>
        <div style="line-height:36px" class="text-eight">
          {{ $t('unverified_alert_content') }}
        </div>
        <v-btn outlined color="white" rounded small :class="$vuetify.breakpoint.xs ? 'ml-3 mr-2' : 'ml-8 mr-5'"
          @click="sendVerify">{{ $t('unverified_alert_cta') }}</v-btn>
      </template>
      <v-icon small color="white" @click="$emit('closeUnverified')">mdi-close</v-icon>
    </v-card>
  </CustomRow>
</template>

<script>
import UM from "@/api/user-management";
import jwt_decode from "jwt-decode";
import { decrypt as AESdecrypt } from "@/vendor/AEScrypto";
import _ from 'lodash';

export default {
  name: 'UnverifiedAlert',
  data() {
    return {
      decodeInfo: null,
      userInfo: {
        userName: "",
        birthday: "",
        gender: "",
        mobile: "", // 手機號碼
        email: "", // 電郵地址
        postalCode: "",
        country: "",
        county: "",
        district: "",
        address: "",
        verifyEmail: null,
      },
      reSendFinished: false,
      maskedUserInfo: {},
    }
  },
  methods: {
    async getUserInfo() {
      this.loadingGetUserInfoFinsed = false;
      if (this.isRegister) this.userInfo.email = this.registerEmail;
      else {
        const user = JSON.parse(Cookies.get("user"));
        const { data } = await UM.getMaskedUserInfo();

        const token = jwt_decode(user.access_token);

        if (!!token.encryptedAddress && !!token.encryptedAddress.encryptedData) {
          this.decodeInfo = AESdecrypt(token.encryptedAddress.encryptedData, token.encryptedAddress.iv) || data.userInfo.address;
        } else {
          this.decodeInfo = data.userInfo.address
        }

        if (data.errCode === "00") {
          const {
            userName,
            birthday,
            mobile,
            email,
            address,
            gender,
            country,
            verifyEmail,
            disability
          } = data.userInfo;
          this.originUserName = userName;
          this.originUserEmail = email;
          this.userInfo.userName = userName || '';
          this.userInfo.birthday = birthday || "";
          this.userInfo.mobile = mobile;
          this.userInfo.email = email;

          this.userInfo = {
            ...this.userInfo,
            ...disability
          };
          this.disabilityForm = {
            ...disability
          }
          this.needDisabilityVerify = disability && !!disability.validDate
          let addressArray = this.decodeInfo ? this.decodeInfo.split(",") : [];

          if (!country || country === 'Taiwan') {
            [
              this.userInfo.postalCode,
              this.userInfo.county,
              this.userInfo.district,
              this.userInfo.address,
            ] = addressArray;
          } else {
            [
              this.userInfo.address,
              this.userInfo.county,
              this.userInfo.district,
              this.userInfo.postalCode,
            ] = addressArray;
          }

          this.userInfo.country = country;
          this.userInfo.gender = gender;
          this.userInfo.verifyEmail = user.verifyEmail;
        } else {
          // todo getUsereInfo fail
          this.showDialog({
            alert: true,
            content: `<div class="pa-6 text-center font-weight-bold">
                <img
                  src="/image/ic-warning@3x.png"
                  alt=""
                  style="width:80px"
                />
                <div class="mt-5">${this.$t("userinfo_loading_error")}<br>${data.errDetail
              }</div>
              </div>`,
          });
          // console.log(
          //   `資料讀取失敗\nerrCode: ${data.errCode}\nerrMsg: ${data.errMsg}\nerrDetail: ${data.errDetail}`
          // );
          setTimeout(() => {
            this.$router.push({ name: "Index" }).catch(() => { });
          }, 2000);
        }
      }
      this.loadingGetUserInfoFinsed = true;
    },

    async sendVerify() {
      this.reSendFinished = false;
      const { data } = await UM.sendEmailVerify();
      if (data.errCode !== "00") {
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
                <img
                  src="/image/ic-warning@3x.png"
                  alt=""
                  style="width:80px"
                />
                <div class="mt-5">${this.$t("send_email_submit_fail")}<br>${data.errDetail
            }</div>
              </div>`,
        });
        // (console.log
        //   `發送失敗\nerrCode: ${data.errCode}\nerrMsg: ${data.errMsg}\nerrDetail: ${data.errDetail}`
        // );
      } else {
        if (!this.showChangeEmailForm) {
          this.updatedEmail = true
          this.showChangeEmailForm = true
        }
      }

      this.reSendFinished = true;
    },
  },
  async beforeMount() {
    await this.getUserInfo()
  }
}
</script>

<style lang="scss" scoped>
.unverified {
  position: sticky;
  top: 64px;
  z-index: 5;
}

.alert-card {
  position: absolute;
  top: 10px;
  right: 0;
  font-size: 14px;
  background: #444444;
  color: white;
  padding: 15px 24px;
  z-index: 4;
  border-radius: $radiusDesktop !important;

  @media screen and (max-width: 600px) {
    padding: 10px 15px;
    border-radius: $radiusMobile !important;
  }

  .v-btn {
    font-size: 0.7rem;
  }
}
</style>
